// components/private/paket/hooks/useRegistrationDetail.ts
import { useQuery } from "@tanstack/react-query";
import { axiosClient } from "@/lib/axiosClient";

export function useRegistrationDetail(
    participantId?: number | null,
    periodId?: number | null,
    enabled = false
) {
    return useQuery({
        queryKey: ["participant-registrations", participantId, periodId],
        queryFn: async () => {
            const { data } = await axiosClient.get(
                `/participants/${participantId}/registrations/period/${periodId}`
            );
            return data?.data ?? null;
        },
        enabled: Boolean(participantId && periodId) && enabled,
        staleTime: 1000 * 60 * 1,
        refetchOnWindowFocus: false,
        retry: 0,
    });
}
